import { apiClient } from './api-client';
import type { School } from '@/types/api';

/**
 * Get logo URL from school data
 * Only returns URL if resourceUrl is available (don't construct from logoId as it's unreliable)
 */
export function getSchoolLogoUrl(school: School): string | null {
  // Only use resourceUrl if available - don't try to construct from logoId
  // The search API doesn't return resourceUrl, so we'll show placeholder for those
  if (school.logo?.resourceUrl) {
    return school.logo.resourceUrl;
  }

  // Don't construct URL from logoId - it's unreliable and causes flashing
  // If only logoId exists, return null to show placeholder
  return null;
}

/**
 * Get initials from school title for placeholder
 */
export function getSchoolInitials(schoolTitle: string): string {
  const words = schoolTitle.trim().split(/\s+/);
  if (words.length >= 2) {
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }
  return schoolTitle.substring(0, 2).toUpperCase();
}

